
import { defineComponent, Ref, ref, onMounted, computed, onBeforeUnmount } from "vue";
import Api from "@/services/Api";
import useAlert from "../../../composables/Alert";
import { useStore } from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { env } from "process";

interface formFiltroType {
  marcaFiltro: string;
  marcaVeiculo: string;
  modelo: string;
  fipe: string;
  anoInicial: string;
  anoFinal: string;
  tipo: string;
}

export default defineComponent({
  name: "ModalDownloadFiltro",
  props: {
    fechaModal: Function,
    pegarListaDePlanilhaFiltroDownload: Function,
    marcasFiltro: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
  },

  setup(props) {
    const { showTimeAlert, showAlert } = useAlert();
    const store = useStore();
    const arquivo: Ref<any> = ref({});

    const modalDialogo: Ref<any> = ref()

    const mensagem: Ref<string> = ref('');

    const formFiltro: Ref<formFiltroType> = ref({ marcaFiltro: "", marcaVeiculo: "", modelo: "", fipe: "", tipo: "", anoInicial: "", anoFinal: "" })

    const arrayMarcas: Ref<any[]> = ref([])
    const arrayMarcasFiltro = computed(() => props.marcasFiltro);

    const loadDownload = ref(false)
    const topicoAtivo = ref<string | null>(null)

    const tipos: Ref<any> = ref([
      'Leve',
      'Pesado'
    ]);

    function aplicaMascara() {
      formFiltro.value.anoInicial = formFiltro.value.anoInicial.replace(/\D/g, '').slice(0, 4);
      formFiltro.value.anoFinal = formFiltro.value.anoFinal.replace(/\D/g, '').slice(0, 4);
    }

    function closeModal() {
      arquivo.value = {};
      props.fechaModal && props.fechaModal()
    }

    function verificaAno(): boolean {
      const { anoInicial, anoFinal } = formFiltro.value
      if (anoFinal && anoInicial > anoFinal) {
        mensagem.value = '*Ano inicial não pode ser maior que o ano final';
        return true
      }
      mensagem.value = ''
      return false
    }

    function verificaTipoVeiculo(){
      const { tipo } = formFiltro.value;
      if( !tipo ) {
        showTimeAlert('Tipo do Veículo é obrigatório', 'error');
        return true
      }
      return false;
    }

    /*
    async function baixar() {

      loadDownload.value = true;

      if (verificaAno()) return;

      const response = await Api.get("downloadPlanilhaFiltrosDatabase", { ...formFiltro.value }, { responseType: 'blob' });

      baixaArquivo(response, 'filtros.xlsx')

      props.fechaModal && props.fechaModal()

      loadDownload.value = false;

    }

    function baixaArquivo(blobParam: any, name: string) {

      const url = URL.createObjectURL(new Blob([blobParam]));
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      link.click();
      URL.revokeObjectURL(url);

    }
      */

    async function gerarRelatorio() {

      if (verificaAno()) return;
      if (verificaTipoVeiculo()) return;

      loadDownload.value = true;

      const { id, error } = await Api.post('gerarPlanilhaFiltroDatabase', {
        ...formFiltro.value
      });

      loadDownload.value = false;

      if(id !== null)  {
        escutarEventoSocket(id);
        props.fechaModal && props.fechaModal()
        props.pegarListaDePlanilhaFiltroDownload && props.pegarListaDePlanilhaFiltroDownload()
        showTimeAlert('A planilha sendo processada', 'success');
      } else {
        console.log(error);
        showTimeAlert('Ocorreu um erro ao processar a planilha', 'error');
      }
    }

    function escutarEventoSocket(id: number) {
      // Obtém o ambiente (deve ser igual ao do backend)
      // Backend converte: dev → local, prod → production
      let ambiente = ''
      if(process.env.VUE_APP_ENV == 'local'){
        ambiente = 'dev'
      } else {
        ambiente = 'prod'
      }
      
      // Cria os tópicos conforme o backend envia
      const topicoSucesso = `${ambiente}-planilha-filtro-pronta-${id}`;
      const topicoErro = `${ambiente}-planilha-filtro-erro-${id}`;

      console.log('=== SOCKET DEBUG ===');
      console.log('Ambiente:', ambiente);
      console.log('ID da planilha:', id);
      console.log('Tópico sucesso:', topicoSucesso);
      console.log('Tópico erro:', topicoErro);
      console.log('Socket conectado?', store.state.SocketModule?.main?.connected);

      // Armazena o tópico para remover depois
      topicoAtivo.value = topicoSucesso;

      // Aguarda um pouco para garantir que o socket está pronto
      setTimeout(() => {
        try {
          // Escuta evento de sucesso
          store.dispatch(Actions.NEW_LISTEN, {
            name: topicoSucesso,
            callbackFunction: (dados: any) => {
              console.log('✅ Planilha pronta recebido:', dados);
              showAlert('A planilha está disponível para download', 'success');
              props.pegarListaDePlanilhaFiltroDownload && props.pegarListaDePlanilhaFiltroDownload();
              removerListenersSocket(topicoSucesso, topicoErro);
            }
          });

          // Escuta evento de erro
          store.dispatch(Actions.NEW_LISTEN, {
            name: topicoErro,
            callbackFunction: (dados: any) => {
              console.log('❌ Erro na planilha recebido:', dados);
              showAlert('Erro ao gerar a planilha', 'error');
              props.pegarListaDePlanilhaFiltroDownload && props.pegarListaDePlanilhaFiltroDownload();
              removerListenersSocket(topicoSucesso, topicoErro);
            }
          });
          
          console.log('Listeners registrados com sucesso');
          console.log('Aguardando eventos no tópico:', topicoSucesso);
        } catch (erro) {
          console.error('Erro ao registrar listeners:', erro);
          showAlert('Erro ao conectar ao servidor de notificações', 'error');
        }
      }, 300); // Aguarda 300ms para socket conectar
    }

    function removerListenersSocket(topicoSucesso: string, topicoErro: string) {
      console.log('Removendo listeners:', { topicoSucesso, topicoErro });
      
      store.dispatch(Actions.REMOVE_LISTEN, { name: topicoSucesso });
      store.dispatch(Actions.REMOVE_LISTEN, { name: topicoErro });
      
      topicoAtivo.value = null;
    }

    /*
    async function baixarRelatorio(id: number) {
      const response = await Api.get(
        `downloadPlanilhaFiltroDatabase/${id}`,
        {},
        { responseType: 'blob' }
      );

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'filtros.xlsx';
      link.click();
      URL.revokeObjectURL(url);
    }
      */

    const getVehicleBrands = async () => arrayMarcas.value = (await Api.get('getAllvehicleBrand')).data.marcas

    onMounted(async () => {
      getVehicleBrands()
      // Inicia a conexão do socket
      store.commit(Mutations.START_SOCKET);
    })

    /*
    onBeforeUnmount(() => {
      // Remove listeners ao sair do componente
      if (topicoAtivo.value) {
        store.dispatch(Actions.REMOVE_LISTEN, { name: topicoAtivo.value });
      }
    })
      */

    return {
      gerarRelatorio,
      arquivo,
      closeModal,
      arrayMarcas,
      arrayMarcasFiltro,
      modalDialogo,
      formFiltro,
      verificaAno,
      aplicaMascara,
      mensagem,
      loadDownload,
      tipos
    };
  },
});
